import { FiFile } from '@react-icons/all-files/fi/FiFile';

import { MarketplaceDocument } from '../useDocumentUpload';
import DocumentsPanelRow, { ViewFileButton } from './DocumentsPanelRow';

type OtherDocumentRowProps = {
  document: MarketplaceDocument;
};

const OtherDocumentRow = ({ document }: OtherDocumentRowProps) => (
  <DocumentsPanelRow
    thumbnailUrl={document.contentType.startsWith('image/') ? document.url : null}
    fallbackIcon={FiFile}
    name={document.filename}
    actions={<ViewFileButton url={document.url} />}
  />
);

export default OtherDocumentRow;
